import NavigationBarControl from '../../../lib/ui/NavigationBarControl'
import IndexList from '../../../lib/ui/IndexControl'
import LocationForm from '../ui/LocationForm'
import LogentryModel from '../../logentry/model/LogentryModel'
import LocationModel from '../model/LocationModel'
import ObjectTypeMapping from '../../constants/ObjectTypeMapping'

export default class EditLocation {
  constructor (element, args) {
    this.onchange = () => {
      this.data = this.locationForm.getValue()
      window.PRIM.initDelayedNavigation()
      window.PRIM.dataAccess.put('locations', this.data.getJSON()).then((location) => {
        if (!window.PRIM.isDelayedNavigationActive())
        {
          return
        }

        if (args && !args.id && location.id) {
          window.PRIM.navigate('/locations/' + location.id, true)
        }

        if (location) {
          this.data.values.id = location.id
          this.locationForm.setValue(this.data)
        }        
      })
    }

    if (args) {
      if (args.id) {
        window.PRIM.dataAccess.resolve('locations', args.id, true).then((location) => {
          this.data = location
          this.locationForm.setValue(this.data)

          window.PRIM.dataAccess.resolve('positions', this.data.values.id, true, 'location_id').then((positions) => {
            this.data.positions = positions
            this.positionIndex.setItems(this.data.positions)
          }, () => {
          }).catch(() => {
          })

          window.PRIM.dataAccess.get('logentries').then((logentries) => {
            let results = logentries.filter((logentry) => {
              return logentry.target_id === this.data.values.id && logentry.object_type_id === ObjectTypeMapping.location
            })

            this.data.logentries = results.map((logentry) => {
              return new LogentryModel(logentry)
            })

            this.logIndex.setItems(this.data.logentries)
            this.locationForm.setValue(this.data)
          }, () => {
            this.locationForm.setValue(this.data)
          }).catch(() => {
          })
        }, () => {
          if (confirm('Deze vestiging bestaat niet, mogelijk is deze intussen verwijderd. Wilt u een nieuwe vestiging aanmaken?')) {
            window.PRIM.navigate('/locations/')
          } else {
            history.back()
          }
        }).catch(() => {
        })
      } else if (args.organisation_id) {
        window.PRIM.dataAccess.resolve('organisations', args.organisation_id, true).then((organisation) => {
          this.data = new LocationModel()
          this.data.values.organisation_id = organisation.values.id
          this.data.organisation = organisation
          this.locationForm.setValue(this.data)
        })
      }
    }

    this.data = new LocationModel()

    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'Vestiging bewerken',
      leftHandButtons: [{
        onclick: () => {
          history.back()
        },
        icon: '\ue00d'
      },
        {
          onclick: () => {
            history.forward()
          },
          icon: '\ue01a'
        },
        {
          onclick: () => {
            window.PRIM.navigate('/start/')
          },
          icon: '\ue08a'
        },
        {
          onclick: this.onchange,
          icon: '\ue020',
          classes: 'indicator'
        }],
      contextMenu: [
        {
          onclick: () => {
            if (this.data.values.id) {
              window.PRIM.navigate('/positions/location/' + this.data.values.id)
            } else {
              alert('Vul eerst gegevens voor deze afdeling.')
            }
          },
          icon: '\ue034',
          label: 'Functie'
        },
        {
          onclick: () => {
            if (this.data.values.id) {
              window.PRIM.navigate('/logentries/location/' + this.data.values.id)
            } else {
              alert('Vul eerst gegevens voor deze vestiging.')
            }
          },
          icon: '\ue032',
          label: 'Logboekregel'
        },
        {
          onclick: () => {
            if (this.data.values.id) {
              if (confirm('Weet u het zeker dat u deze vestiging wilt verwijderen?')) {
                window.PRIM.dataAccess.delete('locations', this.data.values.id).then(() => {
                  history.back()
                })
              }
            } else {
              alert('Vul eerst gegevens voor deze vestiging.')
            }
          },
          icon: '\ue123',
          label: 'Verwijderen'
        }
      ]
    })

    let div = document.createElement('div')
    div.className = 'viewport'

    let divContent = document.createElement('div')
    divContent.className = 'content'

    let primaryData = document.createElement('section')
    primaryData.className = 'primary'
    let secondaryData = document.createElement('section')
    secondaryData.className = 'secondary'

    this.locationForm = new LocationForm(primaryData, {location: this.data, onchange: this.onchange})

    let fieldsetPositions = document.createElement('fieldset')
    let legendPositions = document.createElement('legend')
    legendPositions.innerHTML = 'Functies'
    fieldsetPositions.appendChild(legendPositions)

    let onclickPositions = (item) => {
      window.PRIM.navigate('/positions/' + item.values.id)
    }

    this.positionIndex = new IndexList(fieldsetPositions, {items: this.data.positions, onclick: onclickPositions})

    secondaryData.appendChild(fieldsetPositions)

    let fieldsetLog = document.createElement('fieldset')
    let legendLog = document.createElement('legend')
    legendLog.innerHTML = 'Logboek'
    fieldsetLog.appendChild(legendLog)

    let onclickLogentry = (item) => {
      window.PRIM.navigate('/logentries/' + item.values.id)
    }

    this.logIndex = new IndexList(fieldsetLog, {items: this.data.logentries, reverse: true, showImage: false, onclick: onclickLogentry})

    secondaryData.appendChild(fieldsetLog)

    divContent.appendChild(primaryData)
    divContent.appendChild(secondaryData)
    div.appendChild(divContent)
    fragment.appendChild(div)

    element.appendChild(fragment)
  }
}



// WEBPACK FOOTER //
// ./js/modules/location/action/EditLocation.js